/*
 * @Descripttion: 主视窗 控制路由
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-06-08 09:57:49
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-21 14:32:27
 */
import React, { Fragment } from 'react'
import { Route, Switch, Redirect, HashRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Helmet } from "react-helmet"
import { GlobalStyled } from '../../style.js';
import UserLogin from '../UserLogin/index'
import ResetPwd from '../ResetPwd/index'
import Home from '../Pages/Home/NewHome'
import Introduce from '../Pages/Home/Introduce'
import Guide from '../Pages/Guide/index'
import UserRegister from '../UserRegister/index'
import UserMessage from './UserMessage'
import LiveManager from './LiveManager'
import UserCenter from './UserCenter/index'
import UserChat from './UserChat/index'
import Upload from './ResourceCtrl/fileupload'
import Download from './ResourceCtrl/filedownload'
import Repository from './ManagerCenter/RepositoryManager/index'
import NewsBulletin from './NewsBulletin/index'
import QACenter from './Q&ACenter/Q&ACenter_new/index'
import QAdetial from './Q&ACenter/Q&ACenter_new/QAdetail'
import QAmessage from './Q&ACenter/Q&ACenter_new/QAmessage.js'
import QAask from './Q&ACenter/QAask'
import CloudStorage from './CloudStorage/index'
import OnlineTraining from './OnlineTraining/index'
import TrainingDetail from "./OnlineTraining/TrainingDetail";
import OnlineClass from './OnlineClass/index'
import Geovis2 from './GeovisResource/loadable'
import Iframe from './Iframe/index'
import UserResource from './UserResource'
import ProcessDesign from './ProcessDesign'
import './index.css'
import OnlineClassWindow from './OnlineClass/OnlineWindow'
import GuideSearch from './Guide/guidesearch'
import ConfigPage from '../../config/ConfigPage'
import { getCookie } from 'src/utils/checkCookie'
import { loadUserLocal, zd_loadUserLocal } from 'src/service/loginaction_yunguan'
import Header4 from '../Header/Header4'
import AbourUs from './Guide/component/MainBottom/AbourUs'
import JoinUs from './Guide/component/MainBottom/JoinUs'
import ContactUs from './Guide/component/MainBottom/ContactUs'
import ProductInspection from './OtherWeb/ProductInspection'
import Chat from './Chat/index'
import OnlineHelp from './OnlineHelp/index'
import OnlineApi from './OnlineApi/index'
import NetIntroduce from './Guide/IntroducePages/NetIntroduce'
import ResourcesSearch from './Guide/IntroducePages/ResourcesSearch'
import TechnicalService from './Guide/IntroducePages/TechnicalService'
// 算法模型共享
import AlgorithmModelSharing from './AlgorithmModalAndTools/AlgorithmModelSharing/index'
// 算法工具共享
import AlgorithmToolsSharing from './AlgorithmModalAndTools/AlgorithmToolsSharing/index'
// 微波遥感特征检索界面
import SearchOfMicrRomoteSensing from './SearchOfMicrRomoteSensing/index'
// 三维可视化界面
import ThreeDimensionsVisulization from './ThreeDimensionsVisulization/index'
import SatelliteDetail from './Home/Introduce/component/SatelliteSystem/SatelliteDetail'
import Shopping from './Shopping/index.js'
// import DownloadPage from './DownloadPage/DownloadPage.js'
import DownloadListItemDetail from './UserCenter/components/MyOrder/components/DownloadListItemDetail'
import FutureListItemDetail from './UserCenter/components/MyOrder/components/FutureListItemDetail'
import TempBaotouData from "./TempBaotouData/index.js";
import MeetSharingData from "./MeetSharingData/index";
import SimulationData from "./SimulationData";
import Presentation from "./Presentation";
import PresentationDetail from "./Presentation/PresentationDetail";
import Developing from "./Developing/index";
//权限的分配给定  门户自己能用的  分为浏览权限及使用权限  
const privilegeTree = {
    name: 'root',
    path: '/',
    children: [
        {
            name: "论坛",
            url: "/Q&ACenter",
            children: [
                {
                    name: "论坛浏览",
                    url: "/Q&ACenter",
                    children: []
                }, {
                    name: "论坛删帖",
                    url: "/Q&ACenter",
                    children: []
                },
            ]
        }
    ]
}

class MainWindow extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            renderRouter: []
        }
    }

    // document.body.removeEventListener('touchmove',bodyScroll,false);
    bodyScroll() {
        // event.preventDefault();
        // debugger
        // console.log('window.screen.height:    ' + window.screen.height)
        // console.log('document.body.scrollHeight:    ' + document.body.scrollHeight)

    }

    shouldComponentUpdate(preProps, PreState) {
        if (preProps.user.userId !== this.props.user.userId) {
            // this.renderComponent()
            return true
        }
        if (preProps.user === this.props.user) {
            // this.renderComponent()
            return true
        }
        return false
    }
    ////首先进行身份验证
    componentWillMount() {

        // 改成自己的登录接口，把这里注掉了，后期要是用运管的接口，记得解开
        let token = getCookie('token')
        token && loadUserLocal(token)
        //浙大token
        let zd_param = {
            userName: "SYY_USER",
            password: "SYY_135_!@%23$psw"
        }
        let zd_token = getCookie('zd_token')
        zd_token && zd_loadUserLocal(zd_token, zd_param)

        let userInfo = getCookie('userInfo')
        // if (userInfo !== 'undefined') {
        //     loadUserLocal(userInfo)
        // }


    }
    async componentDidMount() {
        this.renderComponent()
    }

    getQueryVariable(search, variable) {
        var query = search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    }

    renderComponent = () => {
        if (!this.props.user.token) return
        let RouterList = JSON.parse(localStorage.getItem('RouterList'))
        if (Array.isArray(RouterList) && RouterList.length > 0) {
            let finalRoutes = RouterList.map((item, index) => {
                let url = item.url
                if (item.param) {
                    url += this.generateParamsString(item)
                    if (item.param.indexOf('id') === -1)
                        return <Route path={item.link} exact component={(props) => {
                            let id = this.getQueryVariable(props.location.search, 'id')
                            if (id)
                                url += '&id=' + id
                            return <><Header4 /><Iframe blank={item.blank} url={url}></Iframe></>
                        }} />
                    else {
                        return <Route path={item.link} exact component={() => <><Header4 /><Iframe blank={item.blank} url={url}></Iframe></>} />
                    }
                } else {
                    return <Route path={item.link} exact component={() => <><Header4 /><Iframe blank={item.blank} url={url}></Iframe></>} />
                }
            })
            return finalRoutes
            // console.log(finalRoutes)
            // this.setState({
            //     renderRouter: finalRoutes
            // })
        }
    }

    generateParamsString = ({ url, param }) => {
        let params = param.split(';')
        const { user } = this.props
        let resultString = ''
        url.indexOf('?') === -1 ? resultString += '?' : resultString += '&'
        params.map((item, index) => {
            switch (item) {
                case 'token':
                    resultString += 'token=' + user.token + '&'
                    break;
                case 'userToken':
                    resultString += 'userToken=' + user.token + '&'
                    break;
                case 'zd_token':
                    resultString += 'zd_token=' + user.zd_token + '&'
                    break;
                case 'userName':
                    resultString += 'userName=' + user.userName + '&'
                    break;
                case 'userId':
                    resultString += 'userId=' + user.userId + '&'
                    break;
                default:
                    break;
            }
        })
        resultString = resultString.substring(0, resultString.length - 1)
        return resultString
    }

    render() {

        //通过 调用接口获得权限信息
        const qxxx = {
            "code": 1,
            "data": {
                "cellphone": "15700729703",
                "company": "五十四所",
                "duty": "工程师",
                "email": "1@163.com",
                "name": "zzan",
                "privilegeTree": [
                    {
                        "id": 1,
                        "modify": false,
                        "name": "新闻公告浏览",
                        "privilegeCode": "1",
                        "privilegeId": 1,
                        "softwareId": 0,
                        "superiorPermissionNumber": 0,
                        "systemId": 0,
                        "type": 1,
                        "url": "/",
                        "children": [

                        ]
                    }
                ],
                "realName": "张赞",
                "roleIds": [],
                "roleInfos": [
                    {
                        "addPersonnelNumber": "",
                        "description": "运管超级管理员",
                        "modify": true,
                        "name": "运管超级管理员",
                        "privilegeIds": [],
                        "privilegesWithoutDelete": [],
                        "roleId": 26,
                        "softwareId": 101001,
                        "subsystemId": 101
                    }
                ],
                "roleNames": "运管超级管理员",
                "userId": 2000000448
            },
            "message": "success"
        }
        const { user, zd_user } = this.props;
        return (
            <Fragment>
                <HashRouter >
                    <Helmet>
                        <title>国家民用空间基础设施共性技术支撑服务网</title>
                    </Helmet>
                    <GlobalStyled />
                    <Switch>
                        <Route path='/Home' component={Home} />
                        <Route exact path='/Introduce' component={Introduce} />
                        <Route exact path='/Introduce/SateliteDetail' component={SatelliteDetail} />
                        <Route exact path='/Shopping' component={Shopping} />
                        <Route path='/Guide' component={Guide} />
                        <Route path='/GuideSearch' component={GuideSearch} />
                        <Route path='/UserRegister' component={UserRegister} />
                        <Route path='/UserLogin' component={UserLogin} />
                        <Route exact path='/ResetPwd' component={ResetPwd} />
                        <Route path='/UserCenter' component={UserCenter} />
                        <Route path='/UserChat' component={UserChat} />
                        <Route exact path='/Q&ACenter' component={QACenter} />
                        <Route exact path='/Q&ADetail/:id' component={QAdetial} />
                        <Route exact path='/Q&AMessage' component={QAmessage} />
                        <Route path='/Q&Aask' component={QAask} />
                        <Route path='/NetIntroduce' component={NetIntroduce} />
                        <Route path='/ResourcesSearch' component={ResourcesSearch} />
                        <Route path='/TechnicalService' component={TechnicalService} />
                        <Route path='/AbourUs' component={AbourUs} />
                        <Route path='/JoinUs' component={JoinUs} />
                        <Route path='/ContactUs' component={ContactUs} />
                        <Route path='/Upload' component={Upload} />
                        <Route path='/Download' component={Download} />
                        <Route path='/Geovis' component={Geovis2} />
                        <Route path='/OnlineTraining' component={OnlineTraining} />
                        <Route path='/TrainingDetail' component={TrainingDetail} />
                        <Route path='/CloudStorage' component={CloudStorage} />
                        <Route path='/Repository' component={Repository} />
                        <Route path='/NewsBulletin' component={NewsBulletin} />
                        <Route path='/LiveManager' component={LiveManager} />
                        <Route path='/userresource' component={UserResource} />
                        <Route path='/processdesign' component={ProcessDesign} />
                        <Route path='/OnlineClass/Center' component={OnlineClass} />
                        <Route path='/OnlineClass/:id' component={OnlineClassWindow} />
                        <Route path='/userMessage' component={UserMessage} />
                        <Route path='/config' component={ConfigPage} />
                        <Route path='/Iframe' exact component={Iframe} />
                        <Route path='/OnlineHelp' component={OnlineHelp} />
                        <Route path='/onlineApi' exact component={OnlineApi} />
                        <Route path='/AlgorithmModelSharing' exact component={AlgorithmModelSharing} />
                        <Route path='/AlgorithmToolsSharing' exact component={AlgorithmToolsSharing} />
                        <Route path='/SearchOfMicrRomoteSensing' exact component={SearchOfMicrRomoteSensing} />
                        <Route path='/ThreeDimensionsVisulization' exact component={ThreeDimensionsVisulization} />
                        <Route path='/ProductInspection' exact component={ProductInspection} />
                        <Route path='/chat' component={Chat} />
                        <Route path='/GXWBCPCX' exact component={Geovis2} />
                        <Route path='/DownloadListItemDetail' exact component={DownloadListItemDetail} />
                        <Route path='/FutureListItemDetail' exact component={FutureListItemDetail} />
                        <Route path='/BaotouData' exact component={TempBaotouData} />
                        <Route path='/NanjingData' exact component={MeetSharingData} />
                        <Route path='/ShoupiData' exact component={MeetSharingData} />
                        <Route path='/WenchangData' exact component={MeetSharingData} />
                        <Route path='/SimulationData' exact component={SimulationData} />
                        <Route path='/Presentation' exact component={Presentation} />
                        <Route exact path='/Presentation/PresentationDetail'  component={PresentationDetail} />

                        <Route path="/Developing" exact component={Developing} />
                        {
                            this.renderComponent()
                        }
                        {/* <Route path='/CPTJ' exact component={() => <><Header4 /><Iframe url='http://landv.aircas.ac.cn:7164/ZSXGeok/html/map/airStation.html?page=zsx&token=NSE*1666148897569@F7K9_2000001821_50ecff323acd48ecaf3089b4d8282b6a'></Iframe></>} />
                        <Route path='/JYCL' exact component={() => <><Header4 /><Iframe url='http://landv.aircas.ac.cn:7164/ZSXGeok/html/map/airStation.html?page=zsx&token=NSE*1666148897569@F7K9_2000001821_50ecff323acd48ecaf3089b4d8282b6a'></Iframe></>} />
                        <Route path='/FZYZ' exact component={() => <><Header4 /><Iframe url='http://landv.aircas.ac.cn:7164/ZSXGeok/html/map/airStation.html?page=zsx&token=NSE*1666148897569@F7K9_2000001821_50ecff323acd48ecaf3089b4d8282b6a'></Iframe></>} />
                        <Route path='/GXWB' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/ZSXGeok/html/map/airStation.html?page=zsx&token=${user.token}`}></Iframe></>} />
                        <Route path='/DC' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.140:19081/TaskList`}></Iframe></>} />
                        <Route path='/ZDCL' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/StationNetworkSurvey/#/login?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZDYQ' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/Monitorsystemssw/#/login?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZDYQJK' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/Monitorsystemssw/#/login?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZDCLRW' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/MeasurementTaskManagement/#/TodoTasks?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZHSY' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/ZSXGeok/html/map/airStation.html?page=zhsy&token=${user.token}`}></Iframe></>} />
                        <Route path='/SYJH' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/JoinTheComprehensiveExperiment/#/WorkBench?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZHSYRW' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/ComprehensiveExperimentManagement/#/Experiment?token=${user.token}`}></Iframe></>} />
                        <Route path='/JZYZHSY' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/ZSXGeok/html/map/jzsys.html?token=${user.token}`}></Iframe></>} />
                        <Route path='/CLYQ' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/GroundSharingsew/#/InstrumentCalibration?token=${user.token}`}></Iframe></>} />
                        <Route path='/FZFX' exact component={() => <><Header4 /><Iframe url='http://caplos.aircas.ac.cn:19089/cms/#/?token=NSE%2a1669013779799%40P7EW_2000001828_7b665c5e6b8f47ccba8ba5ada9d6069c'></Iframe></>} />
                        <Route path='/ZWSJ' exact component={() => <><Header4 /><Iframe url='http://caplos.aircas.ac.cn/NsicatFront/main/stationPretreatment?token=NSE*1669168334283@3XHK_2000001828_3c07f9b89f4d4e1692751f991ba891dd'></Iframe></>} />
                        <Route path='/SYSJ' exact component={() => <><Header4 /><Iframe url='http://caplos.aircas.ac.cn/NsicatFront/main/dataPretreatment?token=NSE*1669168334283@3XHK_2000001828_3c07f9b89f4d4e1692751f991ba891dd'></Iframe></>} />
                        <Route path='/DMSJ' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/finecalibrations/#/blank?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZZSJ' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/GroundSharingsew/#/grounddatashare?token=${user.token}`}></Iframe></>} />
                        <Route path='/DXSJ' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/GroundSharingsew/#/Datasetsharing?token=${user.token}`}></Iframe></>} />
                        <Route path='/JYCGFB' exact component={() => <><Header4 /><Iframe url={`http://landv.aircas.ac.cn:7164/GroundSharing/#/ProductInspectionReport?token=${user.token}`}></Iframe></>} />
                        <Route path='/GXWBCPJY' exact component={(props) => {
                            let id = this.getQueryVariable(props.location.search, 'id')
                            return <><Header4 /><Iframe url={`/lxyweb/kjweb/#/Map?token=${user.token}&id=${id}`}></Iframe></>
                        }} />
                        <Route path='/DCCPCX' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.140:19082/dcfz_display_web/?userId=${user.userId}&userName=${user.userName}&userToken=${user.token}`}></Iframe></>} />
                        <Route path='/DCCPJY' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.140:19082/basics_uap_web/?userId=${user.userId}&userName=${user.userName}&userToken=${user.token}`}></Iframe></>} />
                        <Route path='/GXWBCL' exact component={() => <><Header4 /><Iframe url={`/lxyweb/kjwebAdmin/#/Order/DJYOrder?token=${user.token}`}></Iframe></>} />
                        <Route path='/GXJS' exact component={() => <><Header4 /><Iframe url={`http://caplos.aircas.ac.cn/gxpt?token=${user.token}`}></Iframe></>} />
                        <Route path='/BZGF' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/space/standardSpecification/#/homePage?token=${user.token}`}></Iframe></>} />
                        <Route path='/SYCZ' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/shiyanpeixun/#/homePage?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZNYGYY' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.131:8808/IrsaclWeb/static/home?token=${user.token}`}></Iframe></>} />
                        <Route path='/QYHZ' exact component={() => <><Iframe blank={true} url={`http://124.16.188.150:28148/#/about`}></Iframe></>} />
                        <Route path='/ZWRWGL' exact component={() => <><Iframe blank={true} url={`http://124.16.188.150:10088/transportsystem/#/login?token=${user.token}`}></Iframe></>} />
                        <Route path='/KJDMCW' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/ZSXGeok/html/map/map.html?token=${user.token}`}></Iframe></>} />

                        <Route path='/WDDZ' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/OrderDownload/#/DownloadAuditList?token=${user.token}&show=3`}></Iframe></>} />
                        {/*<Route path='/LSSYZL' exact component={() => <><Header4 /><Iframe url={`http://124.16.188.150:10088/ZSXGeok/#/business/wddqsy/ctquery?token=${user.token}`}></Iframe></>} />*/}
                        <Route path='/LSSYZL' exact component={() => <><Header4 /><Iframe url={`https://landv.aircas.ac.cn:10088/space/ExperimentManagement/#/experimentalField?token=${user.token}`}></Iframe></>} />
                        <Route path='/ZSXWXGL' exact component={() => <><Header4 /><Iframe url={`https://landv.aircas.ac.cn:10088/space/SatelliteTransitManagement/#/Testhouse?distinguish=1&token=${user.token}`}></Iframe></>} />
                        <Route path='/ZHWXGL' exact component={() => <><Header4 /><Iframe url={`https://landv.aircas.ac.cn:10088/space/SatelliteTransitManagement/#/Testhouse?distinguish=2&token=${user.token}`}></Iframe></>} />
                        <Redirect path='/' to='/Home'></Redirect>
                    </Switch>
                </HashRouter>
            </Fragment>
        );
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})

const mapDispatch = () => ({
})

export default connect(mapState, mapDispatch)(MainWindow);